import styles from "@/styles/legal/faq.module.scss"
import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import Wholesale from "@/components/productDetail/Wholesale"
import TabBar from "@/components/TabBar"
import { UpOutlined } from '@ant-design/icons';

import PaymentIcon from "@/svgs/faq/payment-icon.svg"
import ShippingIcon from "@/svgs/faq/shipping-icon.svg"
import AccountIcon from "@/svgs/faq/account-icon.svg"
import ProductsIcon from "@/svgs/faq/products-icon.svg"
import WarrantyIcon from "@/svgs/faq/warranty-icon.svg"
import NewsletterIcon from "@/svgs/faq/newsletter-icon.svg"
import CouponIcon from "@/svgs/faq/coupon-icon.svg"
import PaymentIconActive from "@/svgs/faq/payment-icon-active.svg"
import ShippingIconActive from "@/svgs/faq/shipping-icon-active.svg"
import AccountIconActive from "@/svgs/faq/account-icon-active.svg"
import ProductsIconActive from "@/svgs/faq/products-icon-active.svg"
import WarrantyIconActive from "@/svgs/faq/warranty-icon-active.svg"
import NewsletterIconActive from "@/svgs/faq/newsletter-icon-active.svg"
import CouponIconActive from "@/svgs/faq/coupon-icon-active.svg"

import { Button } from 'antd'

import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function Faq() {

  const [activeTab, setActiveTab] = useState(0)
  const tabList = [
    { 
      id: 1,
      name: 'Payment',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 0 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 0 
              ? <PaymentIcon style={{ width: '50px', textAlign: 'center' }}></PaymentIcon>
              : <PaymentIconActive style={{ width: '50px', textAlign: 'center' }}></PaymentIconActive>
            }
          </div>
          <div
            className={styles['item-name']}
            style={{ color: activeTab == 0 ? '#D70B17' : '#999999' }}
          >Payment</div>
        </div>
    },
    { 
      id: 2,
      name: 'Shipping & Delivery',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
      <div className={`${styles['custom-item']} ${activeTab == 1 ? styles['active-item'] : ''}`}>
        <div className={styles['item-icon']}>
            {
              activeTab != 1
              ? <ShippingIcon style={{ width: '50px', textAlign: 'center' }}></ShippingIcon>
              : <ShippingIconActive style={{ width: '50px', textAlign: 'center' }}></ShippingIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 1 ? '#D70B17' : '#999999' }}
          >{`Shipping & Delivery`}</div>
        </div>
    },
    { 
      id: 3,
      name: 'My Account',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 2 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 2
              ? <AccountIcon style={{ width: '50px', textAlign: 'center' }}></AccountIcon>
              : <AccountIconActive style={{ width: '50px', textAlign: 'center' }}></AccountIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 2 ? '#D70B17' : '#999999' }}
          >My Account</div>
        </div>
    },
    { 
      id: 4,
      name: 'Products',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 3 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 3
              ? <ProductsIcon style={{ width: '50px', textAlign: 'center' }}></ProductsIcon>
              : <ProductsIconActive style={{ width: '50px', textAlign: 'center' }}></ProductsIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 3 ? '#D70B17' : '#999999' }}
          >Products</div>
        </div>
    },
    { 
      id: 5,
      name: 'Warranty & Returns',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 4 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 4
              ? <WarrantyIcon style={{ width: '50px', textAlign: 'center' }}></WarrantyIcon>
              : <WarrantyIconActive style={{ width: '50px', textAlign: 'center' }}></WarrantyIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 4 ? '#D70B17' : '#999999' }}
          >{`Warranty & Returns`}</div>
        </div>
    },
    { 
      id: 6,
      name: 'Newsletter',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 5 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 5
              ? <NewsletterIcon style={{ width: '50px', textAlign: 'center' }}></NewsletterIcon>
              : <NewsletterIconActive style={{ width: '50px', textAlign: 'center' }}></NewsletterIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 5 ? '#D70B17' : '#999999' }}
          >Newsletter</div>
        </div>
    },
    { 
      id: 7,
      name: 'CrazyPoints & Coupon',
      itemWidth: 'calc(100% / 7)',
      reactNode: 
        <div className={`${styles['custom-item']} ${activeTab == 6 ? styles['active-item'] : ''}`}>
          <div className={styles['item-icon']}>
            {
              activeTab != 6
              ? <CouponIcon style={{ width: '50px', textAlign: 'center' }}></CouponIcon>
              : <CouponIconActive style={{ width: '50px', textAlign: 'center' }}></CouponIconActive>
            }
          </div>
          <div 
            className={styles['item-name']}
            style={{ color: activeTab == 6 ? '#D70B17' : '#999999' }}
          >{`CrazyPoints & Coupon`}</div>
        </div>
    }
  ]

  // 切换tab，展示不同的内容
  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  // 点击目录item，跳转到指定Faq的定位
  const scrollToTarget = (index: number) => {
    // 获取Faq目标div
    const targetDiv = document.getElementById(`${activeTab}${index}`);

    if (targetDiv) {
      // 计算目标div的位置
      const targetDivRect = targetDiv.getBoundingClientRect()

      // 滚动到目标div的位置
      window.scrollTo({
        top: targetDivRect.top - 90,
        behavior: 'smooth', // 添加平滑滚动效果
      })
    }
  }

  // 回到顶部
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 添加平滑滚动效果
    })
  }

  // 批发佬弹窗控制
  const [isWholesaleOpen, setIsWholesaleOpen] = useState(false);
  const openWholesale = () => {
    setIsWholesaleOpen(true);
  };

  const closeWholesale = () => {
    setIsWholesaleOpen(false);
  };

  interface QuestionItem {
    question: string;
    answer: React.ReactNode;
  }

  const pageData = [
    [
      {
        question: 'What payment methods do you accept?',
        answer: 
          <div className={styles['answer-desc']}>
            We accept bank cards (credit or debit cards), PayPal (Visa cards, Mastercards and bank accounts), BPAY, Afterpay and ZipPAY. All these payment methods are user-friendly, secure and efficient.
          </div>
      },
      {
        question: 'How does Paypal work?',
        answer: 
          <div className={styles['answer-desc']}>
            <Link
              href="https://www.crazysales.com.au/article/AboutPayPal"
              legacyBehavior
            >
              <a 
                className={styles['link']}
                style={{ color: '#D70B17' }}
                rel="noopener noreferrer"
              >
                Please visit How does Paypal works?
              </a>
            </Link>
          </div>
      },
      {
        question: 'How does BPAY work?',
        answer: 
          <div className={styles['answer-desc']}>
            <Link
              href="https://www.crazysales.com.au/article/AboutBPAY"
              legacyBehavior
            >
              <a 
                className={styles['link']}
                style={{ color: '#D70B17' }}
                rel="noopener noreferrer"
              >
                Please visit How does BPAY works?
              </a>
            </Link>
          </div>
      },
      {
        question: 'Can I pay with my bank card or credit card?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes, you can pay by your bank card or credit card via Paypal, or you can pay by your credit or debit card directly.
          </div>
      },
      {
        question: 'Can I pay by money order, bank cheque or direct deposit?',
        answer: 
          <div className={styles['answer-desc']}>
            We do not accept money order, cheque or direct deposit, as these payment methods will slow down our dispatch time and ultimately, the time to deliver your item will be prolonged.
          </div>
      },
      {
        question: 'How long do I have until I have to pay for my order?',
        answer: 
          <div className={styles['answer-desc']}>
            You will need to make payment for your order in 2 days.
          </div>
      },
      {
        question: 'Do your prices include GST?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes, all our prices are GST included.<br />
            (Ships from and sold by GlobalOutlet.com not Include GST)
          </div>
      },
      {
        question: 'What happens if I do not have a credit card?',
        answer: 
          <div className={styles['answer-desc']}>
            You can pay by BPAY, it will allow you to pay from your bank account via phone banking or Internet banking service. Please visit How does BPAY work?
          </div>
      },
      {
        question: 'Is your site safe for credit card usage?',
        answer: 
          <div className={styles['answer-desc']}>
            CrazySales.com.au uses advanced encryption and state-of-the-art SSL (Secure Sockets Layer) so you can be assured that your information will be protected from any unauthorised usage. You can also be assured that your confidential information will remain confidential.
          </div>
      },
      {
        question: 'There is a coupon code field in the checkout page, what is it and how can I get one?',
        answer: 
          <div className={styles['answer-desc']}>
            From time to time we will run certain promotions where we will send coupon code to our members. These are usually a certain dollar value, a percentage off the order or free shipping. Would you like to receive a coupon code? Please subscribe to our newsletter now!
          </div>
      },
      {
        question: 'Is Lay-by available?',
        answer: 
          <div className={styles['answer-desc']}>
            Sorry, we do not provide Lay-by service.
          </div>
      },
      {
        question: 'How long does it take to confirm my payment?',
        answer: 
          <div className={styles['answer-desc']}>
            If you pay by Paypal immediate payment (credit card option), we will be able to confirm your payment immediately and we will dispatch your order within 1 business day. If you pay by BPAY before 6:00pm, we will be able to confirm your payment on the next business day.
          </div>
      },
      {
        question: 'Where can I change my payment method?',
        answer: 
          <div className={styles['answer-desc']}>
            {`Simply log into your account, click on “My Account”->“Order History”. All of your previous orders will be displayed. Then click the order ID you want to change and click the payment method that you want to use to process the payment.`}
          </div>
      },
      {
        question: 'What is a CSC Code?',
        answer: 
          <div className={styles['answer-desc']}>
            The Card Security Code (CSC), sometimes called Card Verification Value or Code (CVV or CVC), is a security feature for credit or debit card transactions, giving increased protection against credit card fraud.
            <br />
            <br />
            There are actually two security codes:
            <br />
            1. The first code, called CVC1 or CVV1,is encoded on the magnetic strip of the card and used for transactions in person.<br />
            2. The second code, and the most cited, is CVV2 or CVC2. This CSC (also known as a CCID or Credit Card ID) is often asked for by merchants for them to secure &quot;card not present&quot; transactions occurring over the Internet, by mail, fax or over the phone. In many countries in Western Europe, due to increased attempts at card fraud, it is now mandatory to provide this code when the cardholder is not present in person.
            <br />
            <br />
            This latter CSC should not be confused with the standard card account number appearing in embossed or printed digits. (The standard card number undergoes a separate validation algorithm called the Luhn algorithm which serves to determine whether a given card&apos;s number is appropriate.)
          </div>
      }
    ],
    [
      {
        question: 'When will you ship out my order?',
        answer: 
          <div className={styles['answer-desc']}>
            Most of the items will be sent out in the next business day after we have confirmed your payment.You will be notified via an email with a unique tracking number and delivery details.
          </div>
      },
      {
        question: 'Which couriers do you use?',
        answer: 
          <div className={styles['answer-desc']}>
            We use Australia Post
            &nbsp;
            <Link
              href="https://www.aramex.com.au/tools/track/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                Aramex
              </a>
            </Link>
            &nbsp;,&nbsp;
            <Link
              href="https://www.alliedexpress.com.au/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                Allied Courier
              </a>
            </Link>
            &nbsp;,&nbsp;
            <Link
              href="https://www.hunterexpress.com.au/tracking/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                Hunter
              </a>
            </Link>
            &nbsp;,&nbsp;
            <Link
              href="https://track.sendle.com/tracking/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                Sendle
              </a>
            </Link>
            &nbsp;
            and TIG Freight Management. Orders within Victoria, Australia receive Standard Shipping which will be either eParcel or TIG (whichever is more cost effective).
          </div>
      },
      {
        question: 'Where can I track my order?',
        answer: 
          <div className={styles['answer-desc']}>
            If your goods have been dispatched, just click on the following link --please make sure you have your tracking number ready. 
            <br />
            1. eParcel / eParcel Express:
            &nbsp;
            <Link
              href="https://auspost.com.au/mypost/track/#/search"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://auspost.com.au/mypost/track/#/search
              </a>
            </Link><br />
            2. Aramex / Fastway:
            &nbsp;
            <Link
              href="https://www.aramex.com.au/tools/track/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.aramex.com.au/tools/track/
              </a>
            </Link><br />
            3. Allied Courier:
            &nbsp;
            <Link
              href="http://www.alliedexpress.com.au/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                http://www.alliedexpress.com.au/
              </a>
            </Link><br />
            4. Allied Express:
            &nbsp;
            <Link
              href="https://www.alliedexpress.com.au/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.alliedexpress.com.au/
              </a>
            </Link><br />
            5. Regular Mail:
            &nbsp;
            this option does not include parcel tracking numbers and fixed ETA times
            <br />
            6. Hunter:
            &nbsp;
            <Link
              href="https://www.hunterexpress.com.au/tracking/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.hunterexpress.com.au/tracking/
              </a>
            </Link><br />
            7. Icumulus:
            &nbsp;
            <Link
              href="https://tracking.icumulus.cloud/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://tracking.icumulus.cloud/
              </a>
            </Link><br />
            8. Fast House:
            &nbsp;
            <Link
              href="https://au.fh.express/pc/search"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://au.fh.express/pc/search
              </a>
            </Link><br />
            9. Sendle:
            &nbsp;
            <Link
              href="https://try.sendle.com/en-au/tracking"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://try.sendle.com/en-au/tracking
              </a>
            </Link><br />
            10.International Registered Post:
            &nbsp;
            <Link
              href="https://www.17track.net/en"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.17track.net/en
              </a>
            </Link><br />
            11. Kinisi:
            &nbsp;
            <Link
              href="https://kinisitransport.com/tracking/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://kinisiglobal.com/track-shipment/
              </a>
            </Link><br />
            12. Shippit:
            &nbsp;
            <Link
              href="https://www.shippit.com.sg/track-your-package/"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.shippit.com.sg/track-your-package/
              </a>
            </Link><br />
            13. Couriers Please:
            &nbsp;
            <Link
              href="https://www.couriersplease.com.au/tools-track"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.couriersplease.com.au/tools-track
              </a>
            </Link>
          </div>
      },
      {
        question: 'Why have I received a different item from what I ordered?',
        answer: 
          <div className={styles['answer-desc']}>
            Please contact us with your order number. We will resolve this mistake as soon as possible.
          </div>
      },
      {
        question: 'What should I do if my item arrived with missing parts?',
        answer: 
          <div className={styles['answer-desc']}>
            Please contact us with your order number. We will resolve this mistake as soon as possible.
          </div>
      },
      {
        question: 'Are parcels covered by transit insurance?',
        answer: 
          <div className={styles['answer-desc']}>
            All delivery shipments are fully insured . If your item is lost in transit, we will replace it at our cost.
          </div>
      },
      {
        question: 'Do you deliver everywhere in Australia?',
        answer: 
          <div className={styles['answer-desc']}>
            eParcel and Hunter deliver Australia wide including residential, business and PO BOX addresses. However, there are a small number of areas that they are unable to deliver to, such as Norfolk, Christmas Island and Cocos Island.
            <br />
            <br />
            Alternatively, you may simply input your postcode in the &quot;Your Postcode&quot; box of each product listing to enquire about deliverable locations. If the postcode is an area that the courier is able to deliver, it will automatically display the postage fee. If &quot;Wrong postcode&quot; is displayed, it means either you have input an invalid postcode or that area is not a deliverable location.
          </div>
      },
      {
        question: 'Do you ship internationally?',
        answer: 
          <div className={styles['answer-desc']}>
            Currently we are unable to make shipments to locations beyond Australia. However,we are considering the potential of expanding globally. We will keep you informed via our weekly Newsletter. Subscribe to our Newsletter now.
          </div>
      },
      {
        question: 'Do you provide combine shipping service?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes we provide combine shipping for most of our Products.
            <br />
            <br />
            Products eligible for combined shipping are marked as &quot;Combine Shipping & Save&quot;. To take advantage, just add two or more eligible products to your shopping cart. 
            <br />
            Please check the “Help”section for terms and conditions.
          </div>
      },
      {
        question: 'Can you ship my item by express post?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes we can ship via Express Post for an additional fee. Please select the Express Post option when checking out your order for Express Post Delivery.
          </div>
      },
      {
        question: 'Can I or my own courier pick up my order from your warehouse?',
        answer: 
          <div className={styles['answer-desc']}>
            We are unable to offer a pickup because we ensure that you receive your goods as soon as possible by limiting its delivery mechanisms. Offering a pick up service would complicate our logistics process and delay delivery time for all customers.
          </div>
      },
      {
        question: 'What happens if I am not at home when the courier delivers my orders?',
        answer: 
          <div className={styles['answer-desc']}>
            If your package is to be delivered by eParcel / Aramex / Sendle to a residential address, and no one is available to sign for the parcel, our 3rd party courier will check if the item is safe to leave at the door. If the 3rd party courier deemed it not safe to leave at the door then a card with contact information will be left; you can then contact courier to arrange for a second delivery.
            <br />
            For smaller items, if no one is available to sign for the parcel, our 3rd party courier will leave the item at the nearest Local Post Office and you would need to pick up the item.
            <br />
            Please contact us if you did not receive the item and we will gladly check the location of the item for you.
          </div>
      },
      {
        question: 'What happens if I do not receive my order by the estimated delivery date?',
        answer: 
          <div className={styles['answer-desc']}>
            The estimated delivery date is counted from the day we dispatch your items, we suggest you visit
            &nbsp;
            <Link
              href="https://www-sit.crazysales.com.au/legal/delivery-brand"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                &quot;Where can I track my order?&quot;
              </a>
            </Link>
            &nbsp;
            first, or you can contact us and we will resolve this matter as soon as possible.
          </div>
      },
      {
        question: 'Can you ship my order to my PO BOX address?',
        answer: 
          <div className={styles['answer-desc']}>
            We can ship your order to your PO BOX address via eParcel only. You can find the details in &quot;Shipping info&quot; section of each product page.
          </div>
      },
      {
        question: 'How do I change the shipping address?',
        answer: 
          <div className={styles['answer-desc']}>
            To change address in your account, please log into your account and click on &quot;Address Manager&quot;, then click on &quot;Edit My Address&quot; (which is beside the &quot;default address&quot;) and fill out the detailed address information as requested. Click the “Save” button to finish.
            <br />
            <br />
            However, if you want to change address for a specific order, it’s recommended to send us an email with correct shipping address and contact number. And please be informed that we are not able to change shipping address if the item has already been dispatched.
          </div>
      },
      {
        question: 'Why am I unable to receive any discounts when purchasing two or more products that are eligible for combined shipping?',
        answer: 
          <div className={styles['answer-desc']}>
            We have 2 exceptions to the combine shipping system:
            <br />
            <br />
            a) Due to minimum charges set by courier companies, there may be no additional shipping discount for individual items weighing less than 0.5kg.
            <br />
            b) Items shipped via regular mail can only be combined with multiples of the exact same product to receive a combined shipping discount.
          </div>
      },
      {
        question: 'What kind of new delivery choices do you offer now? Any extra charge?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              Crazysales now offers a range of advanced delivery choices with Australia Post to make it easier and more convenient for you to receive your purchases with us. Please note that we can only deliver your parcel on the selected day if the payment for your order is confirmed within the day. The options provided are according to the ETA (Estimated Time of Arrival) of your postcode, and unfortunately we are unable to provide over-night delivery.
              <br />
              <br />
              These choices include:
            </div>

            <div className={styles['status-table']}>
              <div className={styles['status-table-header']}>
                <div className={styles['header-item']}>New Delivery Choices</div>
                <div className={styles['header-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Service Choices Details</div>
                <div className={styles['header-item']}>Extra Charge</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>Date Specific Delivery</div>
                <div className={styles['content-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Customer elects for parcel delivery to an address on a specific day(s) of the week (Monday - Friday)</div>
                <div className={styles['content-item']}>$3.6</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>Day Specific Delivery</div>
                <div className={styles['content-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Customer elects for a parcel delivery to an address on a specific date (Monday - Friday)</div>
                <div className={styles['content-item']}>$3.6</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>AM / PM Delivery Window</div>
                <div className={styles['content-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Customer elects for parcel delivery to an address within an AM or PM delivery window (7am -12pm, 12pm – 5pm Monday - Friday)</div>
                <div className={styles['content-item']}>$7.2</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>AM/ PM Delivery Window and Day / Date</div>
                <div className={styles['content-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Customer elects for parcel delivery to an address, within an AM or PM delivery window and a day / date for delivery  (Monday - Friday)</div>
                <div className={styles['content-item']}>$9</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>Customer Collection Points</div>
                <div className={styles['content-item']} style={{ width: '55%', textAlign: 'center', flexShrink: 0 }}>Customer elects to collect their parcel from one of the convenient Australia Post collection points</div>
                <div className={styles['content-item']}>No charge</div>
              </div>
            </div>
          </>
      },
      {
        question: 'Why can’t I choose an AM/PM Delivery Window?',
        answer: 
          <div className={styles['answer-desc']}>
            At this stage delivery choice options are not available to all addresses and locations. If the options are available to your shipping address, our system will show the options automatically for you at the checkout process.
          </div>
      },
      {
        question: 'What happens if no one is available to sign for the parcel at we have chosen?',
        answer: 
          <div className={styles['answer-desc']}>
            A signature is required upon delivery, and if no one is at the delivery address to receive the parcel, a card will be left advising where the parcel can be collected from your nearest post office.
            <br />
            <br />
            Or you could reschedule your parcel to a more convenient time. Please be informed that you may need to pay the associated fees. For this service and further information, you may contact Australia post directly by dialing 13 13 18.
          </div>
      },
      {
        question: 'What if I do not receive my parcel(s) on the guaranteed day/date?',
        answer: 
          <div className={styles['answer-desc']}>
            Our 3rd party courier will make every effort to deliver your product within the estimated delivery time but the actual delivery times may change due to changes in supply or circumstances beyond our control. We encourage you to visit the &quot;My Account&quot; section on our website to view the delivery status of your product. Please contact us if your item/s are not delivered within 45 days from the date of purchase, any claims of non-delivery outside this time frame will be considered delivered to you.
            <br />
            <br />
            If unfortunately that&apos;s the case and if you require assistance, please let us know and we will be happy to investigate with our 3rd party courier to track down your parcel.
            <br />
            <br />
            Please Note: The investigation process can take upto 15 working days to resolve. Once our team receives any outcome from our 3rd party courier company we will contact you immediately to provide a resolution.
          </div>
      },
      {
        question: 'If I want to buy many items in one order, can I choose this service for just some of the items?',
        answer: 
          <div className={styles['answer-desc']}>
            The delivery choices is for shipping methods (normal eParcel & eParcel Express), and not for the number of items in an order. Multiple items are charged once if the shipping method is the same.
          </div>
      },
      {
        question: 'Can free-shipping items enjoy the new delivery choices?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes, you can choose the service during the checkout process.
          </div>
      },
      {
        question: 'Where can I track my parcel if I have chosen the delivery choices?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              Follow the steps in this link to check the progress of your parcel delivery:
            </div>
            <Link
              href="https://www.crazysales.com.au/legal/delivery-brand"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                https://www.crazysales.com.au/legal/delivery-brand
              </a>
            </Link>
          </>
      },
      {
        question: 'Can I check which shipping I have chosen in My Account?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              Yes, you can check your choice by logging into your My Account with CrazySales.com.au under order details page or you can check this information in your account for My Deliveries with Australian Post.
              <br />
              CrazySales.com.au
            </div>
            <br />
            <Image
              className={styles['content-img']}
              src={`${imageDomain}/faq/shipping-pic1.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
          </>
      },
      {
        question: 'What happens if no one collects the article from the Customer Collection Point?',
        answer: 
          <div className={styles['answer-desc']}>
            If you have registered for My Deliveries, you will receive up to two email notifications.
            <br />
            <br />
            1.The first email is generated on receipt of the scan event “Ready for Collection-Customer Collect Outlet” (NT-ER4), indicating the parcel has been received at the CCP and is ready for collection. One email will be sent for each article within a consignment.
            <br />
            2.The second reminder email is automatically sent if the parcel is still waiting collection after 5 working days.
            <br />
            <br />
            <b>NOTE:</b>&nbsp;
            There is no charge to the normal Return to Sender process for articles not collected. The article will be returned to sender if it has NOT been collected within 5 working days.
          </div>
      },
      {
        question: 'Why is that when I ordered multiple items from your website, the items arrive at different times?',
        answer: 
          <div className={styles['answer-desc']}>
            Due to bulk orders shipping out every day, our courier picks up multiple crates at the same time before it gets sorted in their facility, Items can sometimes be placed on mulitple delivery vans and delivery times can vary. Also, Items that come in multiple packages/boxes can also be delivered at different times. Also, sometimes our items will be delivered directly from our supplier which can also vary in delivery times.
          </div>
      },
      {
        question: 'How to Track & Trace Your Item?',
        answer: 
          <>
            <div className={`${styles['answer-desc']} padding-bottom-10`}>
              Log in &quot;My Account&quot;(To log in, please goes to: 
              &nbsp;
              <Link
                href="https://www.crazysales.com.au/login"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  https://www.crazysales.com.au/login
                </a>
              </Link>
              )
              <br />
              After logged in, click the &quot;Track My Order&quot; at the top of the home page.
              <br />
              After you are in the order list, find the order you want to check the logistics, and click &quot;Track Order&quot;,or click &quot;View Detail&quot; to go to the order details, and then click &quot;Track Order&quot;.
              <br />
              Go to tracking site, input tracking number and search.
            </div>
            <Image
              className={styles['content-img']}
              src={`${imageDomain}/faq/shipping-pic2.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
          </>
      },
      {
        question: 'How to Check the ETA?',
        answer: 
          <>
            <div className={`${styles['answer-desc']} padding-bottom-10`}>
              Go to item page;
              <br />
              Enter your postcode in the field next to &quot;Your Postcode&quot;;
              <br />
              The page automatically refreshes and the ETA for your postcode is shown right under &quot;Shipping Carriers&quot;.
            </div>
            <Image
              className={styles['content-img']}
              src={`${imageDomain}/faq/shipping-pic3.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Please also note that deliveries with address on some farms, mine sites, islands, Aboriginal sacred sites and other regional or remote locations may not be accessible to our couriers and will not be able to deliver to your door steps. In such cases our courier will contact you for alternate delivery options.
            </div>
          </>
      }
    ],
    [
      {
        question: 'How do I open an account?',
        answer: 
          <div className={styles['answer-desc']}>
            To create a new account, please click on &quot;Register&quot; button on top of the page, and then fill out the appropriate information. You may start shopping once you have created your new account.
          </div>
      },
      {
        question: 'How do I update my account information?',
        answer: 
          <div className={styles['answer-desc']}>
            To update your &quot;My Account&quot; , please login with your email address and password.
          </div>
      },
      {
        question: 'What should I do if I forgot my login password?',
        answer: 
          <div className={styles['answer-desc']}>
            To retrieve your password, please click on &quot;Forgot Your Password&quot; at the login page, and then enter your billing email address. We will send your password to your billing email address.
          </div>
      },
      {
        question: 'New Discount System for Crazysales.com.au For Regular Orders (Value Customer Program)',
        answer: 
          <>
            <div className={`${styles['answer-desc']} padding-bottom-10`}>
              The Valued Customers is a group of customers who are recognized and respected for their purchases from Crazysalescom.au. Read on to find out more about our Valued Customer Program and how you can join.
              <br />
              <br />
              There are 5 tiers that distinguish a Valued Customer, based on their gross annual purchasing volume. The benefits and services vary with each tier. Each month we calculate eligibility for each tier and members can check their own status by logging into “My Account”.
            </div>

            <div className={styles['discount-table']}>
              <div className={styles['discount-table-header']}>
                <div className={styles['header-item']} style={{ width: '240px', flexShrink: 0 }}></div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv0
                  </div>
                  <div className={styles['item-subtitle']}>
                    Normal
                  </div>
                </div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv1
                  </div>
                  <div className={styles['item-subtitle']}>
                    Bronze
                  </div>
                </div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv2
                  </div>
                  <div className={styles['item-subtitle']}>
                    Silver
                  </div>
                </div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv3
                  </div>
                  <div className={styles['item-subtitle']}>
                    Gold
                  </div>
                </div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv4
                  </div>
                  <div className={styles['item-subtitle']}>
                    Platinum
                  </div>
                </div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Lv5
                  </div>
                  <div className={styles['item-subtitle']}>
                    Titanium
                  </div>
                </div>
              </div>

              <div className={styles['discount-table-content']}>
                <div 
                  className={styles['content-item']} 
                  style={{ width: '240px', flexShrink: 0, fontWeight: 'bold' }}
                >
                  Order Total AU$
                </div>
                <div className={styles['content-item']}>$0-3499</div>
                <div className={styles['content-item']}>$3500</div>
                <div className={styles['content-item']}>$8500</div>
                <div className={styles['content-item']}>$20000</div>
                <div className={styles['content-item']}>$50000</div>
                <div className={styles['content-item']}>$300000</div>
              </div>

              <div className={styles['discount-table-content']}>
                <div 
                  className={styles['content-item']} 
                  style={{ width: '240px', flexShrink: 0, fontWeight: 'bold' }}
                >
                  Crazy Point*
                </div>
                <div className={styles['content-item']}>1X</div>
                <div className={styles['content-item']}>2X</div>
                <div className={styles['content-item']}>3X</div>
                <div className={styles['content-item']}>4X</div>
                <div className={styles['content-item']}>5X</div>
                <div className={styles['content-item']}>6X</div>
              </div>

              <div className={styles['discount-table-content']}>
                <div 
                  className={styles['content-item']} 
                  style={{ width: '240px', flexShrink: 0, fontWeight: 'bold' }}
                >
                  Phone Service
                </div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>YES</div>
                <div className={styles['content-item']}>YES</div>
                <div className={styles['content-item']}>YES</div>
              </div>

              <div className={styles['discount-table-content']}>
                <div 
                  className={styles['content-item']} 
                  style={{ width: '240px', flexShrink: 0, fontWeight: 'bold' }}
                >
                  Local Pick up
                </div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>YES</div>
                <div className={styles['content-item']}>YES</div>
                <div className={styles['content-item']}>YES</div>
                <div className={styles['content-item']}>YES</div>
              </div>

              <div className={styles['discount-table-content']}>
                <div 
                  className={styles['content-item']} 
                  style={{ width: '240px', flexShrink: 0, fontWeight: 'bold' }}
                >
                  {`Pickup Charge Order < $100`}
                </div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>-</div>
                <div className={styles['content-item']}>10</div>
                <div className={styles['content-item']}>10</div>
                <div className={styles['content-item']}>10</div>
                <div className={styles['content-item']}>10</div>
              </div>
            </div>

            <div className={`${styles['answer-desc']} padding-top-10`}>
              Note: Order Total only counts successful orders for the past 12 months (order status: sent). * Please arrange an appointment for pickup
              <br />
              <br />
              <b>For Bulk Orders</b>
              <br />
              Please contact us with the following details - the item model number, the quantity you would like to purchase, and your postcode so that we can check in your bulk order quotation.
              <br />
              Wholesale prices are available,&nbsp;
              <span className={styles['link']} onClick={openWholesale}>contact us</span>
              &nbsp;for more discounts on bulk buys.
              <br />
              <br />
              <b>For Melbourne Local Pick Up</b>
            </div>
            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                We offer a pick up option for customers who are Silver Level or higher.
              </li>
              <li className={styles['answer-list-item']}>
                For orders less than $100, we charge a $10 handling fee.
              </li>
              <li className={styles['answer-list-item']}>
                Pick up option is not available if order contains products from the following categories:Computers & IT/Memory Cards & USB
              </li>
            </ul>
            <div className={styles['answer-desc']}>
              *All on sales, special, clearance items only applicable with 1x Crazy Point
              <br />
              <br />
              <b>Phone Service</b>
            </div>

            <div className={styles['status-table']} style={{ width: '672px' }}>
              <div className={styles['status-table-header']}>
                <div className={styles['header-item']} style={{ width: '50%', textAlign: 'center' }}>New Delivery Choices</div>
                <div className={styles['header-item']} style={{ width: '50%', textAlign: 'center' }}>Service Choices Details</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>General Enquiry</div>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Place phone order (Please visit our site)</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Payment Enquiry</div>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Technical Support (Please email us)</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Delivery Enquiry</div>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Warranty (Please email us)</div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Address Problem</div>
                <div className={styles['content-item']} style={{ width: '50%', textAlign: 'center' }}>Order Discount (Please email us)</div>
              </div>
            </div>

            <div className={`${styles['answer-desc']} padding-top-10`}>
              Crazysales reserves the right to make any changes (whether material or otherwise) to Discount System (Value Customer Program), the Terms and Conditions, the Rewards, Awards or Benefits tier offered and the Fee Schedule.
              <br />
              <br />
              Crazysales will use best efforts to advise Members of material changes to these Terms and Conditions and will post new terms and condition to website at least 30 days before takes effect.
            </div>
          </>
      },
      {
        question: 'How do I change the billing address?',
        answer: 
          <div className={styles['answer-desc']}>
            To change the billing address, please log into your account and click on &quot;Order History&quot;. Then select the order ID and click “Edit Billing Address”. Fill in the detailed address information as requested. Click the “Save” button to finish.
          </div>
      },
      {
        question: 'How do I change my registered email address?',
        answer: 
          <div className={styles['answer-desc']}>
            To change your registered email address, please log into your account and click &quot;Contact Information&quot;. Please enter in your new email address. Click the “Save” button to finish.
          </div>
      }
    ],
    [
      {
        question: 'How do I get answers to specific product questions?',
        answer: 
          <div className={styles['answer-desc']}>
            We are given all the technical specifications by our suppliers and we endeavour to list as much information as possible to help you make your purchase decision. Although our in-house team are keen followers of electronics, IT & consumer goods, we may not always have the expertise to answer very detailed and technical questions we get asked by our buyers. If we do have the information you required , we will respond as soon as possible. Otherwise, may we suggest websites that provide technical information on a wide range of products which will better assist your purchase decision. You may try www.google.com.au
          </div>
      },
      {
        question: 'What should I do if I found the item received is not exactly what was described when I placed the order ?',
        answer: 
          <div className={styles['answer-desc']}>
            We apologise for the incorrect product description provided when you made your purchase, please contact us with your order number. We will resolve this mistake as soon as possible.
          </div>
      },
      {
        question: 'Why are your prices so low?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              CrazySales.com.au can offer prices substantially lower than you would pay in a retail outlet because we:
            </div>

            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                Source our products directly from manufacturers around the world;
              </li>
              <li className={styles['answer-list-item']}>
                Purchase in shipments much larger than most retailers to obtain a better price;
              </li>
              <li className={styles['answer-list-item']}>
                Do not involve or rely on any intermediaries to source our products;
              </li>
              <li className={styles['answer-list-item']}>
                Sell on the Internet only which eliminates expensive retail costs.
              </li>
            </ul>
          </>
      },
      {
        question: 'Can I physically see an item before I purchase it?',
        answer: 
          <div className={styles['answer-desc']}>
            Unfortunately, as CrazySales strives to provide its customers with the lowest prices possible, we are essentially an online store and do not have the capabilities to display products. All of our products are pre-packaged from our suppliers straight to our warehouse, ready to be shipped to you! We will continue to provide highly detailed descriptions, photos and information on all of the items we sell and if you can&apos;t find what you&apos;re looking for there, just contact our fantastic customer service team who will happily help find the information you&apos;re looking for!
          </div>
      },
      {
        question: 'Can you reserve an item for me?',
        answer: 
          <div className={styles['answer-desc']}>
            Due to stock turnover and nature of business, our products are sold on a first order - first sold basis. You may place an order for the item you wish to purchase first and make your payment within 2 days.
          </div>
      },
      {
        question: 'What are Parallel Imports?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              Parallel Imports are a legitimate means to bring authentic products at bargain prices for our customers. They simply refer to products that have been sourced directly from the manufacturer overseas or from a reseller. The quality of parallel imports is identical to retail products except that they have limited warranty but provide cheaper prices for the customer. These items are brand new and come with all the accessories that you would expect to purchase from a retail store, without the big retail price!
            </div>

            <div className={`${styles['answer-desc']} margin-top-32`}>
              For more information on Parallel Import warranty, Please
              &nbsp;
              <Link
                href="https://auspost.com.au/mypost/track/#/search"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  click here
                </a>
              </Link>
              &nbsp;.
            </div> 
          </>
      },
      {
        question: 'How to Find a PID?',
        answer: 
          <>
            <div className={`${styles['answer-desc']} padding-bottom-10`}>
              Go to item page;<br />
              PID number is located at the top of the product&apos;s title.
            </div>

            <Image
              className={styles['content-img']}
              src={`${imageDomain}/faq/products-pic2.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
            
            <div className={`${styles['answer-desc']} margin-top-16 padding-bottom-10`}>
              <b>Method B</b>&nbsp;
              (for customers who have already placed and order):<br />
              Log in &quot;My Account&quot; (To log in, please go to: &nbsp;
              <Link
                href="https://www.crazysales.com.au/login"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  https://www.crazysales.com.au/login
                </a>
              </Link>
              )<br />
              After logging in, click &quot;View Orders&quot; from the drop-down under &quot;My Account&quot; which is located at the upper left corner of the page;<br />
              Go to &quot;Order History&quot;, and click SHOW ALL. Once you have confirmed which order you are referring the PID number is shown under &quot;Products Ordered&quot; column.
            </div>

            <Image
              className={styles['content-img']}
              src={`${imageDomain}/faq/products-pic1.png`}
              alt={'products'}
              width={1016}
              height={417}
            ></Image>
          </>
      },
    ],
    [
      {
        question: 'My item is not working now, but it is still under warranty, how do I claim the warranty?',
        answer: 
          <div className={styles['answer-desc']}>
            <b>How do I make a warranty claim?</b>
            <br />
            Please contact CrazySales by email and give a full detailed description of the problem, as well as a photograph of the faulty product or part and your order number. CrazySales will respond to you within 48 hours with further questions or instructions. 
            &nbsp;
            <b>Do not return the product at this stage.</b>
          </div>
      },
      {
        question: 'What is the procedure for returning my item?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              If goods are faulty, not fit for purpose or do not match description, please contact our Customer Service team to resolve your issue.
              <br />
              Returns are accepted if sent back to us within 30 days of buyer receiving item.
              <br />
              The Package must be unopened.
              <br />
              If you need to return an item, please Contact Us with your order number and details about the product you would like to return. We will respond with instructions for how to return items from your order. Terms and Conditions apply.
              <br />
              You can return the DOA (dead on arrival within 14 days from the date of dispatch) or faulty item to CrazySales using the following steps:
              <br />
            </div>
            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                Send CrazySales an email with your order number and the reason of return.
              </li>
              <li className={styles['answer-list-item']}>
                Our customer service representative will issue you a Faulty Return Form with a Return Authorised Number (RAN). Please ensure you include this Faulty Return Form in your return package. It will enable CrazySales to process your return promptly.
              </li>
              <li className={styles['answer-list-item']}>
                The ARN will provide our Reply Paid number which can be used to return products sent by Australia Post eParcel. In the case of products sent by our courier TOLL IPEC, we will send you details of calling our courier (TOLL IPEC) to pick them up from your place.
              </li>
            </ul>
          </>
      },
      {
        question: 'Who pays the postage costs for an item that has to be returned?',
        answer: 
          <div className={styles['answer-desc']}>
            For the return of items within 14 days DOA, costs will be paid by CrazySales by your use of our Reply Paid number or by our paying our Courier.
            <br />
            <br />
            Where a valid claim is accepted any replaced or repaired items will be sent to you at the expense of CrazySales.
            <br />
            <br />
            Where a claim is not accepted as a valid claim your account will be debited with the cost of you returning the product to CrazySales and of CrazySales returning the product to you as well as a $30.00 handling and administration fee.
            <br />
            <br />
            <b>Items returned COD will not be accepted.</b>
          </div>
      },
      {
        question: 'I have received my item but the packaging has been damaged during transit, can I change the item?',
        answer: 
          <div className={styles['answer-desc']}>
            Package damage during transit is not covered by our conditions or warranties unless the package damage affects the enclosed product. Conditions and warranties apply only to the product.
          </div>
      },
      {
        question: 'I have received my item but the product has been damaged in transit, what should I do?',
        answer: 
          <div className={styles['answer-desc']}>
            All shipments are covered by CrazySales 14 day DOA warranty. Follow the procedures for making a warranty claim. If the damage is discovered outside this period contact Customer Service who will determine whether circumstances are such that you can still proceed with a claim.
            <br />
            <br />
            <b>Please follow the instructions for making a warranty claim and returning a product.</b>
          </div>
      },
      {
        question: 'I have received my item but it is faulty, what should I do?',
        answer: 
          <div className={styles['answer-desc']}>
            <b>Please follow the procedures for making a warranty claim and returning a product.</b>
          </div>
      },
      {
        question: 'Can I transfer the warranty to someone else if I give or sell it to them?',
        answer: 
          <div className={styles['answer-desc']}>
            CrazySales voluntary warranties are non-transferable.
            <br />
            <br />
            Under Statutory Warranties not only the original consumer, but any subsequent owner who received the goods as a gift, is entitled to compensation (provided the goods have not been bought for the purpose of resupply), as long as the goods are returned within a reasonable time.
            <br />
            <br />
            However if you have bought the product from CrazySales for the purpose of selling it to another person you may be responsible for satisfying the Statutory Conditions and Warranties.
          </div>
      },
      {
        question: 'What warranty applies to products sold by CrazySales?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              CrazySales provides a voluntary warranty and applies the Conditions and Warranties required by law.
              <br />
              <br />
              <b>Statutory Conditions and Warranties</b>
              <br />
              For all product sold CrazySales provide conditions and warranties contained in the Commonwealth Trade Practices Act 1974.
              <br />
              Where the 30 Day Change-of-Mind Period has elapsed and the conditions provide that unless the product has defects which CrazySales specifically bring to your attention before the sale, the product is of merchantable quality—that is:
            </div>

            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                the product is free from manufacturing defects and faults and reaches a basic level of quality given the price of the product and any description that is provided with the product;
              </li>
              <li className={styles['answer-list-item']}>
                the product is fit for the purpose or job for which it is normally supplied or to which CrazySales agreed before the sale.
              </li>
              <li className={styles['answer-list-item']}>
                the product matches any description provided on our website or on labelling or packaging; and
              </li>
              <li className={styles['answer-list-item']}>
                you receive clear title to the product
              </li>
            </ul>

            <div className={`${styles['answer-desc']} padding-top-10`}>
              The warranties provide that the product is clear of finance or encumbrances; and you will have free title to the product.
              <br />
              Customers should note that all depictions contained on the website are for illustration purposes only. Because of differences in picture inks, computer monitors and printer ink, colours of the actual product may vary slightly from those observed.
              <br />
              If the product does not fulfil any of these conditions or warranties then, provided the claim is made within a reasonable period after the sale, you may be entitled, at your discretion, to a refund, replacement of the product or to have it repaired. A reasonable period depends on the circumstances of each sale including but not limited to the nature, quality and price of the product.
              <br />
              Any refund agreed to may be less than the purchase price depending on any use or consumption of the product which has occurred or any contribution that use by you has made to the cause of the claim.
              <br />
              Customer Service will consider each claim on its merits on a case by case basis and, if required, will negotiate a solution that is acceptable to CrazySales and you including any costs involved.
              <br />
              For more information about your rights as a consumer, see the ACCC website at www.accc.gov.au or download a free copy of the Warranties and Refunds Guide at 
              &nbsp;
              <Link
                href="http://www.accc.gov.au/content/index.phtml/itemId/322947"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  http://www.accc.gov.au/content/index.phtml/itemId/322947
                </a>
              </Link>.
              <br />
              <br />

              <b>Exceptions</b>
              <br />
              CrazySales do not provide a refund, credit or exchange if:
            </div>

            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                you have damaged the product by using it in a way it was not meant to be used.
              </li>
              <li className={styles['answer-list-item']}>
                you have had a defect drawn to your attention before you purchased the product, for example, when products are clearly labelled as seconds or faulty,
              </li>
              <li className={styles['answer-list-item']}>
                the 30 Day Change-of-Mind period has elapsed and the product matches the description provided on our website and is free from manufacturing defects or faults.
              </li>
            </ul>

            <div className={`${styles['answer-desc']} padding-top-20`}>
              <b>Voluntary Warranty Policy</b>
              <br />
              All products sold by CrazySales have a &quot;dead on arrival&quot; (DOA) warranty. This means that if the product is damaged during delivery and a claim is made within 14 days from the date of dispatch, CrazySales will replace or repair the product at our discretion and our cost. If CrazySales have no further stock of the item and it cannot be repaired CrazySales will replace it with a similar product or offer you a full refund.
              <br />
              If the damage is discovered outside the 14 day period contact Customer Service who will determine whether circumstances are such that you can still proceed with a claim. You can take advantage of this offer for up to twelve months after sale.
              <br />
              This warranty does not apply to damaged packaging only and does not detract from your statutory rights.
              <br />
              <br />

              <b>Manufacturers Voluntary Warranty</b>
              <br />
              Many of the products supplied by CrazySales are covered by a Manufacturers voluntary warranty. The terms and conditions of such warranties are beyond our control and it is your choice whether to use such warranties. Where possible the time of such warranty will be shown on our website.
              <br />
              A manufacturers warranty does not detract from your statutory rights.
              <br />
              <br />

              <b>Please note and follow the procedure for making a warranty claim and returning products.</b>
            </div>
          </>
      },
      {
        question: 'Can I get my money back if I do not want this item any more?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              You are not entitled to a refund, exchange, credit, replacement or repair if you:
            </div>
            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                you have damaged the product by using it in a way it was not meant to be used.
              </li>
              <li className={styles['answer-list-item']}>
                you have had a defect drawn to your attention before you purchased the product, for example, when products are clearly labelled as seconds or faulty,
              </li>
              <li className={styles['answer-list-item']}>
              the 30 Day Change-of-Mind period has elapsed and the product matches the description provided on our website and is free from manufacturing defects or faults.
              </li>
            </ul>
          </>
      },
      {
        question: 'What is CrazySales 30 Day Change-of-Mind Policy?',
        answer: 
          <>
            <div className={styles['answer-desc']}>
              <b>The CrazySales 30 Day Change-of-Mind Policy</b>
              Online shopping sometimes means you don&apos;t get exactly what you had in mind. You are welcome to return the item as long as you meet the following terms and conditions as listed below:
              <br />
              <br />

              <b>Terms & Conditions</b>
            </div>

            <ul className={styles['answer-list']}>
              <li className={styles['answer-list-item']}>
                Notification is required within 30 days of purchase date.
              </li>
              <li className={styles['answer-list-item']}>
                Item to be returned must be in their original re-saleable condition with all tags and packaging (ready to be put back on the shelf).
              </li>
              <li className={styles['answer-list-item']}>
                The item/s are NOT opened, used, worn or damaged.
              </li>
              <li className={styles['answer-list-item']}>
                That you DO NOT stick or write anything on the item itself or its packaging. Please only write or place postage stickers on the outer postage packaging.
              </li>
              <li className={styles['answer-list-item']}>
                Some items are not eligible for refund due to hygienic reasons.
              </li>
              <li className={styles['answer-list-item']}>
                The refund amount will not include delivery costs. If the item was delivered for free, delivery cost will be deducted.
              </li>
              <li className={styles['answer-list-item']}>
                Handling fees will apply at 20% of the purchase price.
              </li>
              <li className={styles['answer-list-item']}>
                The return of the item is the responsibility of the buyer.
              </li>
              <li className={styles['answer-list-item']}>
                If the item has sustained damage in transit or does not return as noted above, a revised refund amount may be required.
              </li>
            </ul>

            <div className={styles['answer-desc']}>
              If you would like to take this offer, please send us an email at info@crazysales.com.au and indicate the Order ID the item/s you wish to return and the reason for the return. Our Customer Service team will reply to your email and, if applicable, issue you a Return Authorization (RA) number. All other relevant information will be given to you at this time. Crazysales will not accept any return of any item/s without an RA from our Customer Service Representative.
              <br />
              <br />
              <b>Exclusions</b>
              <br />
              Disposable products such as medical face masks, tissues, toilet paper, etc are not applicable to the CrazySales 30 Day Change-of-Mind Policy.
            </div>
          </>
      }
    ],
    [
      {
        question: 'Do you have a newsletter that I can subscribe to?',
        answer: 
          <div className={styles['answer-desc']}>
            Yes, please input your email address in the Subscribe Form on our &quot;Subscribe Newsletters&quot; page. We will send you our latest newsletters on a tri-weekly or daily basis depending on which newsletter you choose to subscribe to.
          </div>
      },
      {
        question: 'How do I change my email address for newsletter subscriptions?',
        answer: 
          <div className={styles['answer-desc']}>
            You can simply change your login email address in &quot;My Account&quot;, we will update your new login email address as your newsletter email address.
          </div>
      },
      {
        question: 'How do I unsubscribe from your newsletter?',
        answer: 
          <div className={styles['answer-desc']}>
            <Link
              href="http://www.crazysales.com.au/index.php?newsletter=yes"
              legacyBehavior
            >
              <a className={styles['link']} rel="noopener noreferrer">
                Click here
              </a>
            </Link>
            &nbsp;
            to Unsubscribe
          </div>
      }
    ],
    [
      {
        question: 'What are CrazyPoints?',
        answer: 
          <div className={styles['answer-desc']}>
            As a customer in CrazySales.com.au, every dollar you spend will earn you 1 CrazyPoint excluding shipping costs( Spend AUD $1 = Earn 1 CrazyPoint ). CrazyPoints are bonus points that give you even more savings on items! At checkout, simply redeem the points you have earned for further discounts. Earn enough points and get items for FREE!
            <br />
            <br />
            Currently 1,000 CrazyPoints is equal to AUD $10.
            <br />
            e.g. (Your CrazyPoints) X 0.010 = AUD$ Value
          </div>
      },
      {
        question: 'How do I earn CrazyPoints?',
        answer: 
          <div className={styles['answer-desc']}>
            1) CrazyPoints will be credited to your account automatically for every successful transaction (ordered and paid).
            <br />
            <Image
              className={`${styles['content-img']} padding-top-10 padding-bottom-16`}
              src={`${imageDomain}/faq/crazypoint-pic2.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>

            2) After receving your product, you can also write a review to earn 100-400 CrazyPoints.
            <Image
              className={`${styles['content-img']} padding-top-10`}
              src={`${imageDomain}/faq/crazypoint-pic4.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
            <br />

          </div>
      },
      {
        question: 'How do I redeem CrazyPoints?',
        answer: 
          <div className={styles['answer-desc']}>
            You can use CrazyPoints to purchase anything you want in our store. Simply redeem the CrazyPoints during the checkout process in order to get a further discount or earn more crazypoints and you can have a chance to get an item by paying only a $2 minimum fee !
            <br />
            <Image
              className={`${styles['content-img']} padding-top-10`}
              src={`${imageDomain}/faq/crazypoint-pic3.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
          </div>
      },
      {
        question: 'Do CrazyPoints expire?',
        answer: 
          <div className={styles['answer-desc']}>
            CrazyPoints expire in 24 months if unused.
          </div>
      },
      {
        question: 'What is the value of 1,000 CrazyPoints?',
        answer: 
          <div className={styles['answer-desc']}>
            Currently 1,000 CrazyPoints is equal to AUD $10.
            <br />
            e.g. (Your CrazyPoints) X 0.010 = AUD$ Value
          </div>
      },
      {
        question: 'Is there a limit to how many CrazyPoints I can earn?',
        answer: 
          <div className={styles['answer-desc']}>
            No, every member can earn CrazyPoints without any limit!
          </div>
      },
      {
        question: 'Can I transfer my CrazyPoints to another person?',
        answer: 
          <div className={styles['answer-desc']}>
            Sorry, the points are non-transferable.
          </div>
      },
      {
        question: 'Will I earn CrazyPoints for delivery and handling fee?',
        answer: 
          <div className={styles['answer-desc']}>
            Sorry, the delivery and handling fee is excluded when calculating the amount of points earned.
          </div>
      },
      {
        question: 'What happens to my CrazyPoints if I have the item refunded?',
        answer: 
          <div className={styles['answer-desc']}>
            If an item is refunded, the CrazyPoints you have earned by purchasing this product will be deducted from your account.
            <br />
            If an item is purchased using CrazyPoints in conjunction with any other kind of payment, we will refund the money and CrazyPoints you have used.
            <br />
            e.g.
            <br />
            An item is $13 + $3(Delivery and Handling Fee) = Total Amount of $16.
            <br />
            You have used 1000 CrazyPoints (Value = $10) to get $10 discount so total amount now is $6. Then you paid $6 to purchase this item.
            <br />
            You have earned 3 CrazyPoints. (As Delivery and Handling Fee is excluded when calculating the amount of points earned)
            <br />
            To refund this item, you will have 3 CrazyPoints deducted from your account, but will have $6 refunded plus 1000 CrazyPoints back to you.
            <br />
            For other question(s) which isn’t listed above, please email our customer service team at info@crazysales.com.au – our customer service team will be happy to assist you.
          </div>
      },
      {
        question: 'What is a CrazySales coupon code?',
        answer: 
          <div className={styles['answer-desc']}>
            We run promotions or special discounts from time to time that allow for customers to use CrazySales coupon codes to receive discounts on our already low price items. These are usually:
            <br />
            1.) a certain dollar value
            <br />
            2.) a percentage off the order total excluding the delivery and handling fee
            <br />
            3.) a percentage off the delivery and handling fee
            <br />
            Please note that coupon code does not apply to perfume, computers, IT products, wine or DHL/UPS drop ship items and most coupon offers do not apply to on sale, promotional products.
            <br />
            <br />
            To make sure you don&apos;t miss out on any of these great opportunities, make sure you have subscribed our newsletter.
          </div>
      },
      {
        question: 'Where can I obtain the CrazySales coupon codes?',
        answer: 
          <div className={styles['answer-desc']}>
            We release the CrazySales coupon codes in 2 ways:
            <br />
            1.) Private:
            <br />
            We will occasionally offer CrazySales coupon codes for promotions to chosen segments of our membership database.
            <br />
            2.) Public:
            <br />
            We will issue the CrazySales coupon codes in our newsletters or in our advertisements in other media.
            <br />
            <br />
            To make sure you don&apos;t miss out on any of these great opportunities, make sure you have subscribed our newsletters .
          </div>
      },
      {
        question: 'How do I redeem the CrazySales coupon codes?',
        answer: 
          <div className={styles['answer-desc']}>
            You can redeem the CrazySales coupon code during the checkout process in order to receive discount in our already low price item!
            <br />
            <Image
              className={`${styles['content-img']} padding-top-10`}
              src={`${imageDomain}/faq/crazypoint-pic3.png`}
              alt={'products'}
              width={1016}
              height={513}
            ></Image>
          </div>
      },
      {
        question: 'Can I use more than one CrazySales coupon codes in the same transaction?',
        answer: 
          <div className={styles['answer-desc']}>
            Sorry, only one CrazySales coupon code can be used for each transaction (checkout). However some of the CrazySales coupon codes can be used unlimited times in a certain period so that you can enjoy a big discount for every transaction you have with us in a certain period..
            <br />
            <br />
            To make sure you don’t miss out on any of these great opportunities, make sure you havesubscribed our newsletter.
          </div>
      },
      {
        question: 'Why does the coupon code not work when I apply it to my laptop and USB pen drive order?',
        answer: 
          <div className={styles['answer-desc']}>
            Please note that the coupon code offer does not apply to certain categories of items depending on the nature of the coupon code. For accurate details, we highly recommend that you carefully check in the terms and conditions applied to the coupon code.
          </div>
      },
      {
        question: 'CrazySales is committed to your privacy.',
        answer: 
          <div className={styles['answer-desc']}>
            CrazySales is committed to your privacy. You may be concerned about the way in which we use your personal information. We have implemented this Privacy Policy to inform our customers how we use that information. Your personal information is treated with the highest importance and sensitive personal and payment information such as your own email password and credit card details are never stored anywhere on the Internet with our website. All information sent is instantly sent and then encrypted using the latest SSL technology and then sent directly to our processing system.
          </div>
      },
      {
        question: `Why I can't use double CrazyPoints coupon on my order?`,
        answer: 
          <div className={styles['answer-desc']}>
            Double CrazyPoints coupon applies only to a normal user account at Lv0. If your account is Lv1 or above, all double CrazyPoints coupons will not work.
            <br />
            You can login to &quot;My Account&quot; find out what user level you currently have.
            <br />
            Click here to find out more about Value Customer Program
          </div>
      },
    ]
  ]

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles['page-faq']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['faq-content']}>
            <div className={styles['page-title']}>Frequently Asked Questions(FAQ)</div>
            <div className={styles['page-desc']}>Need help using crazysales.com.au?</div>
            <div className={`${styles['page-desc']} padding-bottom-12`}>We strive to offer you the best buying experience online! Click on the topics below for details.</div>

            <TabBar 
              tabList={tabList}
              activeTab={activeTab}
              tabItemRightMargin={'0px'}
              onTabChange={handleTabChange}
            />

            <div className={styles['questions-title-box']}>
              {
                !!(pageData && pageData[activeTab].length) &&
                pageData[activeTab].map((item: QuestionItem, index: number) => (
                  <div 
                    className={styles['title']} 
                    onClick={() => scrollToTarget(index)}
                    key={`title-${activeTab}${index}`}
                  >
                    Q{index + 1}. {item.question}
                  </div>
                ))
              }
            </div>

            <div className={styles['questions-box']}>
              {
                !!(pageData && pageData[activeTab].length) &&
                pageData[activeTab].map((item: QuestionItem, index: number) => (
                  <div key={`faq-${activeTab}${index}`}>
                    <div className={styles['title']} id={`${activeTab}${index}`}>
                      Q{index + 1}. {item.question}
                    </div>
                    <div className={styles['answer']}>{item.answer}</div>
                    <div className={styles['back-top']}>
                      <UpOutlined style={{ color: '#D70B17', marginRight: '4px' }} onClick={backToTop} />
                      <span onClick={backToTop}>Back to Top</span>
                    </div>
                  </div>
                ))
              }
            </div>

            <div className={styles['continue-shopping']}>
              <Link
                href={'/'}
                passHref
                legacyBehavior
              >
                <a rel="noopener noreferrer">
                  <Button className={styles['continue-shopping-btn']}>Continue Shopping</Button>
                </a>
              </Link>
            </div>

            {
              isWholesaleOpen &&
              <Wholesale 
                onClose={closeWholesale}
                isWholesaleOpen={isWholesaleOpen}
              />}
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}